export default __webpack_public_path__ + "static/N0040-313e776867f880860d3c30fc51b9574b.png";